import React from 'react';

import { Thumbnail } from '@pkg/components';

import { type ItemThumbnailProps, type LeavingItemProps, type PresentItemProps } from '../../types';

import { LeavingItem, PresentItem, ThumbnailWrapper } from './styles';

function ItemThumbnail({ id, videoUrl, imageUrl, title }: ItemThumbnailProps) {
    return (
        <ThumbnailWrapper>
            <Thumbnail id={id} videoUrl={videoUrl} imageUrl={imageUrl} title={title} />
        </ThumbnailWrapper>
    );
}

export function Present(thumbnailProps: PresentItemProps) {
    return (
        <PresentItem>
            <ItemThumbnail {...thumbnailProps} />
        </PresentItem>
    );
}

export function Leaving({ forward = false, onAnimationComplete, ...thumbnailProps }: LeavingItemProps) {
    return (
        <LeavingItem custom={forward} onAnimationComplete={onAnimationComplete}>
            <ItemThumbnail {...thumbnailProps} />
        </LeavingItem>
    );
}
